export const role = {
    ADMIN: 1,
    LT: 3,
    SALE: 5
}